import React from 'react';
import {
  withStyles,
} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {
  HorizontalBar, Pie,
  Bar
} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

import Footer from '../BedsAvailabilityCardFooter/BedsAvailabilityCardFooter';
import Moment from 'react-moment';
import styles from './BedsAvailabilityCardBarStyle';

const BedsAvailabilityCardBar = ({ classes,className, claims, onInternmentRequest,occupiedBeds, freeBeds,noOfPatients, allBeds, inputs, outputs, overBeds, dateLastUpdate, height}) => {
  
  
  const chartData = {
    
    datasets: [{
      label: 'ocupate',
      data: [occupiedBeds],
      backgroundColor: ['#029AB1'],

    },
    {
      label: 'libere',
      data: [ freeBeds],
      backgroundColor: [ '#707070',],

    },
    {
      label: 'supraalocare',
      data: [overBeds],
      backgroundColor: ['#ff0000'],

    },
  ],
  };
  const chartOptions = {
   scales: {
     xAxes: [{
       stacked: true,
         ticks: {
           display:false
         }
         
     }],
      yAxes: [{ stacked:true}]
   },
   
   	  tooltips: {
        enabled:true, 
   	    mode: 'index',
   	    intersect: false
   	  },
   responsive: true,
   
    maintainAspectRatio: false,
    plugins: {
        datalabels: {
          backgroundColor: function (context) {
            return context.hovered ? 'red' : context.dataset.backgroundColor;
          },
          borderColor: 'white',
          borderRadius: 30,
          borderWidth: 2,
          color: 'white',
         
          display: function (context) {
            
            var dataset = context.dataset;
            var count = dataset.data.length;
            var value = dataset.data[context.dataIndex];
            return value>0;
          },
          anchor: 'center',
          
          font: {
            weight: 'bold',
            size: '34'
          },
          listeners: {
            enter: function (context) {
              context.hovered = true;
              return true;
            },
            leave: function (context) {
              context.hovered = false;
              return true;
            }
          },
          formatter: function (value, context) {
            return value.toString().length==1 ? ' ' + value + ' ' : value;
          }
        }
    }
  };

  
  return (
    
    <Paper className={className || classes.bedsAvailabilityRoot}>
      <div className={classes.currentDate}>
     
      </div>
      <div className={classes.freeBedsCount}>
        <Typography className={classes.freeBedsCountNumber} variant="h4">
        {freeBeds==1 ? freeBeds + ' Pat Liber.' : freeBeds + ' Paturi Libere.' }
         {overBeds>0 ? <span className={classes.overBedsCountNumber}> Supraalocare {overBeds}.</span>:<span></span> }
         {claims>0 ? <p className={classes.claimsCountNumber}> In Asteptare {claims}.</p>:<span></span> }
         </Typography>
      </div>
      <div className={classes.chartWrapper}>
        <HorizontalBar height={height*0.4 } data={chartData} options={chartOptions} />
      </div> 
      <div className={classes.inputoutputs}>
      <div className={classes.input}>
      <Typography variant="subtitle1">Astazi <br/><Moment format = "DD MMM YYYY" interval={10000}/></Typography>
      </div>
      <div className={classes.input}>
      <Typography variant="subtitle1">{inputs} Internari</Typography>
      </div>
      <div className={classes.input}>
      <Typography variant="subtitle1">{outputs} Externari</Typography>
      </div>
      </div> 
      <Footer className={classes.footer} label="Actualizat:" value={<Moment fromNow >{dateLastUpdate}</Moment>} onInternmentRequest={onInternmentRequest}/>
      <div style={{ gridColumn: "1 / span 3", gridRow: 6, textAlign: "center", fontSize: 16, whiteSpace: "nowrap", padding: "0 8px 12px", color: "#555" }}>
        Total Paturi 22 * temporar (lipsa asistenti)
      </div>
    </Paper>
  );
};

export default withStyles(styles)(BedsAvailabilityCardBar);
